import { render, staticRenderFns } from "./ManagePushNotificationForm.vue?vue&type=template&id=a0ee8ca4&"
import script from "./ManagePushNotificationForm.vue?vue&type=script&lang=js&"
export * from "./ManagePushNotificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports